import { Box, Typography } from "@mui/material";
import I18n from "i18next";

import MzButton from "@markaaz/ui/MzButton";
import DrawerList from "commonComponents/DrawerList";
import ReportFrequency from "./ReportFrequency";
import ThresholdsMain from "./ThresholdMain";
import CheckboxAccordian from "./CheckboxAccordian";

import firmographicsListItems from "data/firmographics.json";
import ApprovalStatus from "./ApprovalStatus";

const sx = {
  configurationWrapper: {
    marginTop: "80px",
    maxWidth: "465px"
  },
  title: {
    color: "darkBlue.c100",
    marginBottom: "30px"
  },
  description: {
    color: "darkBlue.c100",
    marginBottom: "20px"
  },
  footer: {
    display: "flex",
    marginTop: "50px",
    width: "100%",
    alignItems: "center"
  },
  confirmedBox: {
    display: "flex"
  },
  bulletIcon: {
    marginLeft: "20px",
    borderRadius: "50px",
    height: "16px",
    width: "16px",
    background: (theme) => theme.palette.acqua.c110
  },
  confirmedOn: {
    marginLeft: "10px",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: (theme) => theme.palette.blue.c100
  }
};

const businessHealthListItems = [`Bankruptcy Indicator`, `Markaaz Failure Risk Score`, `Markaaz Credit Risk Score`];

function BusinessMain({
  isMonitorDisabled,
  BusinessV,
  handleBusinessChange,
  toggleMonitoringBusiness,
  submittingMonitoringBusiness,
  handleBusinessSubmit
}) {
  return (
    <Box>
      <ReportFrequency isChecked={!isMonitorDisabled} onChange={toggleMonitoringBusiness} />
      <ThresholdsMain values={BusinessV} onChange={handleBusinessChange} disabled={isMonitorDisabled} />
      <Box sx={sx.configurationWrapper}>
        <Typography variant="h6" sx={sx.title}>
          {I18n.t("monitoringConfiguration.configurationSetting")}
        </Typography>
        <Typography variant="body2" sx={sx.description}>
          {I18n.t("monitoringConfiguration.configurationDescription")}
        </Typography>
        <CheckboxAccordian
          checked={!!BusinessV?.monitoringFirmographics}
          disabled={isMonitorDisabled}
          onCheckboxClick={() => {
            if (isMonitorDisabled) return;
            handleBusinessChange({ key: "monitoringFirmographics", value: !BusinessV?.monitoringFirmographics });
          }}
          label={I18n.t("applicationOnboarding.firmographic")}
        >
          <DrawerList listItems={firmographicsListItems} />
        </CheckboxAccordian>
        <Box sx={{ height: "10px" }} />
        <CheckboxAccordian
          checked={!!BusinessV?.monitoringHealth}
          disabled={isMonitorDisabled}
          onCheckboxClick={() => {
            if (isMonitorDisabled) return;
            handleBusinessChange({ key: "monitoringHealth", value: !BusinessV?.monitoringHealth });
          }}
          label={I18n.t("applicationOnboarding.businessHealth")}
        >
          <DrawerList listItems={businessHealthListItems} />
        </CheckboxAccordian>
      </Box>
      <Box sx={sx.footer}>
        <MzButton
          variant="contained"
          size="large"
          loading={submittingMonitoringBusiness}
          onClick={handleBusinessSubmit}
        >
          {I18n.t("applicationOnboarding.confirmConfiguration")}
        </MzButton>
        <ApprovalStatus data={BusinessV} />
      </Box>
    </Box>
  );
}

export default BusinessMain;
